import {ExportTemplateType} from '../../../../service/reviews/export-constructor/export-constructor-type';
import {CommentsLayoutType} from '../../../../service/reviews/reviews-report';

export const enum ExportConstructorListFormEnum {
    SelectedTemplateId = 'selectedTemplateId',
    Name = 'name',
    AdditionalUserEmails = 'additionalUserEmails',
    CommentsLayout = 'commentsLayout',
    WithReviewsSummary = 'withReviewsSummary',
    WithTagsStat = 'withTagsStat',
}

export type ExportConstructorListFormType = {
    [ExportConstructorListFormEnum.SelectedTemplateId]: number | null;
    [ExportConstructorListFormEnum.Name]: string;
    [ExportConstructorListFormEnum.AdditionalUserEmails]?: string;
    [ExportConstructorListFormEnum.CommentsLayout]: CommentsLayoutType;
    [ExportConstructorListFormEnum.WithReviewsSummary]: boolean;
    [ExportConstructorListFormEnum.WithTagsStat]: boolean;
};

export const enum ExportConstructorEditorFormEnum {
    Name = 'name',
    SelectedColumnIds = 'selectedColumnIds',
    TagsFormat = 'tagsFormat',
    AutotagsFormat = 'autotagsFormat',
    AddressFormat = 'addressFormat',
    AuthorFormat = 'authorFormat',
    WithReviewsSummary = 'withReviewsSummary',
    WithTagsStat = 'withTagsStat',
    SaveAsTemplate = 'saveAsTemplate',
}

export type AddressFormatType = 'separate' | 'merged';

export type AuthorFormatType = 'single' | 'separate';

export type ExportConstructorEditorFormType = {
    [ExportConstructorEditorFormEnum.Name]: string;
    [ExportConstructorEditorFormEnum.SelectedColumnIds]: Array<string>;
    [ExportConstructorEditorFormEnum.TagsFormat]: 'comma' | 'separate';
    [ExportConstructorEditorFormEnum.AutotagsFormat]: 'comma' | 'separate';
    [ExportConstructorEditorFormEnum.AddressFormat]: AddressFormatType;
    [ExportConstructorEditorFormEnum.AuthorFormat]: AuthorFormatType;
    [ExportConstructorEditorFormEnum.WithReviewsSummary]: boolean;
    [ExportConstructorEditorFormEnum.WithTagsStat]: boolean;
    [ExportConstructorEditorFormEnum.SaveAsTemplate]: boolean;
};

export type ExportConstructorEditorModeType = 'create' | 'edit' | 'clone';

export type ExportConstructorEditorStateType = {
    mode: ExportConstructorEditorModeType;
    templateId?: number;
    sourceTemplateId?: number;
    sourceTemplate?: ExportTemplateType;
    initialSheetType?: string;
};
